module.exports = __webpack_public_path__ + "img/san_mobile.f42d460d.png";